<template>
    <svg class="icons">
        <use v-bind:xlink:href="`#${iconName}`" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'Icons',
        props: {
            iconName: {
                type: String,
                default: '',
            },
        },
    });
</script>

<style lang="scss" scoped>
$iconsSizes: (
    12: "12px",
    16: "16px",
    18: "18px",
    20: "20px",
    24: "24px",
    28: "28px",
    32: "32px",
    40: "40px",
);

.icons {
    display: inline-block;
    fill: currentcolor;
    transform: rotate(0);

    &.icons-rotated {
        animation: rotate-center 0.6s ease-in-out both;
    }

    &.icons-disabled {
        opacity: 0.8;
    }

    @each $key, $size in $iconsSizes {
        &.iconsSize-#{$key} {
            width: #{$size};
            min-width: #{$size};
            height: #{$size};
            min-height: #{$size};
        }
    }
}
</style>
